import { QueryClient } from './queryRuntime';

export const queryKeys = {
  publicRoot: ['public-data'],
  listings: ['public-data', 'listings'],
  profiles: ['public-data', 'profiles'],
  brochures: ['public-data', 'brochures'],
  commercialOffers: ['public-data', 'commercial-offers'],
  providers: ['public-data', 'providers'],
  mediaAssets: ['public-data', 'media-assets'],
  adBlocks: ['public-data', 'ad-blocks'],
  adImages: ['public-data', 'ad-images'],
  reviews: ['public-data', 'reviews'],
  chats: (userId) => ['private-data', 'chats', userId],
  reservations: (userId) => ['private-data', 'reservations', userId],
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
    },
  },
});
